import { Button } from "@/components/ui/button";

// Archive-customer confirmation. The trigger is the icon-only Archive button in
// the header card; this renders only the custom-z-index modal (NOT a shadcn
// Dialog — the lower-level overlay stacks above the Radix Sheet).
export function ArchiveCustomerSection({
  archiveConfirmOpen, setArchiveConfirmOpen,
  selectedClient,
  handleArchive,
}) {
  if (!selectedClient) return null;
  return (
    <>
      {/* Custom-overlay confirm — z-100 keeps it above the Sheet's
          own backdrop. Click outside (the backdrop) cancels; the
          inner panel stops propagation to avoid that. */}
      {archiveConfirmOpen && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100]"
          onClick={() => setArchiveConfirmOpen(false)}
        >
          <div
            className="bg-white rounded-lg p-6 max-w-sm mx-4 shadow-xl"
            onClick={(e) => e.stopPropagation()}
            data-testid="archive-confirm-modal"
          >
            <h3 className="text-sm font-semibold text-slate-800 mb-2">Remove Customer?</h3>
            <p className="text-xs text-slate-500 mb-4">
              This customer will be moved to the archive. You can restore them at any time.
            </p>
            <div className="flex justify-end gap-2">
              <Button
                size="sm" variant="outline"
                className="h-7 text-xs"
                onClick={() => setArchiveConfirmOpen(false)}
                data-testid="archive-cancel-btn"
              >Cancel</Button>
              <Button
                size="sm"
                className="h-7 text-xs bg-red-600 hover:bg-red-700 text-white"
                data-testid="archive-confirm-btn"
                onClick={() => {
                  handleArchive(selectedClient.id);
                  setArchiveConfirmOpen(false);
                }}
              >Remove</Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
